<template>    
    <v-container fluid  class="main">
      <LeftMenu/>  
       <v-layout row wrap>  
           <Progress :show="this.showProgress" />
           <v-flex xs1></v-flex>
            <v-flex xs11>
                <v-row
                    class="mb-6"
                    no-gutters
                >
                    <v-col md="7" class="pa-2" >
                        <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                                <v-combobox
                                    :items="suppliers"
                                    label="Select Supplier"
                                    v-model="delivery.supplier"
                                    item-text="name"
                                    single-line
                                    return-object
                                    v-on:change="getPurchasesBySupplier"
                                    >
                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.contactPerson }}  - {{ data.item.name }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        {{ data.item.contactPerson }}  - {{ data.item.name }}
                                    </template>
                                </v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md3>
                                <DatePicker picker-label="Delivery Date" :date-value="delivery.deliveryDate" @dateSelected="delivery.deliveryDate=$event" /> 
                            </v-flex> 
                            <v-flex xs12 sm6 md2/>


                            <v-flex xs12 sm6 md6>
                                <v-combobox
                                    :items="purchases"
                                    label="Select Purchase"
                                    v-model="delivery.purchase"
                                    item-text="id"
                                    single-line
                                    return-object
                                    >
                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.purchaseDate }}  - {{ data.item.explanation }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        {{ data.item.purchaseDate }}  - {{ data.item.explanation }}
                                    </template>
                                </v-combobox>                 
                            </v-flex>  
                            <v-flex xs12 sm6 md1> </v-flex>                 
                            <v-flex xs12 sm6 md1>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>          
                            </v-flex>  
                           
                            <v-flex xs12 sm6 md1>  </v-flex>

                            <v-flex xs12 sm6 md11>
                                <v-textarea v-model="delivery.explanation"  :outlined="true"
                                :auto-grow="true" :clearable="true"
                                label="Explanation"></v-textarea>
                            </v-flex>   
                            <v-flex xs12 sm6 md11/>
                        </v-layout>
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        
                            <v-layout row wrap>                                         
                                <v-flex xs12 >
                                    <Documents :documents="this.delivery.documents" master-category="OFFER" :folder-id="this.delivery.folderId"
                                               :parentRecord="this.delivery.id" :readonly="true" @documentsChanged="getDelivery" />
                                </v-flex>                                            
                            </v-layout>      
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="7" class="pa-2" >
                        
                        <v-layout wrap >   
                            <v-flex v-if="delivery.id" xs12 sm6 md6>
                                <v-combobox
                                :items="delivery.purchase.materials"
                                label="Select Material"
                                v-model="newMaterial.material"
                                item-text="material.materialName"     
                                item-value="id"       
                                v-on:change="materialSelected"                     
                                chips
                                return-object
                                ></v-combobox>
                            </v-flex>   
                            <v-flex v-if="delivery.id" xs12 sm6 md1>
                                <v-text-field v-model="newMaterial.quantity"   label="Quantity"></v-text-field>
                            </v-flex>
                            <v-flex v-if="delivery.id" xs12 sm6 md2>                              
                                <v-combobox
                                    :items="stockList"
                                    label="Select Stock"
                                    item-text="name"
                                    v-on:change="stockSelected"
                                    single-line
                                    return-object
                                ></v-combobox>
                            </v-flex>
                            <v-flex v-if="delivery.id" xs12 sm6 md2>                              
                                <v-combobox
                                    :items="sectionList"
                                    label="Select Section"
                                    v-model="newMaterial.stockSection"
                                    item-text="name"
                                    single-line
                                    return-object
                                ></v-combobox>
                            </v-flex>
                            <v-flex v-if="delivery.id" xs12 sm6 md1>                              
                                <v-btn v-if="isDeliveryEditable(delivery)" color="primary" dark class="mb-2" @click="addMaterial(delivery)">Add</v-btn>
                            </v-flex> 
                    
                            
                            <v-flex v-if="delivery.id && loaded" xs12 sm6 md12>
                                <v-data-table
                                    :key="materialTableKey"
                                    :headers="deliveryMaterialHeaders"
                                    :items="delivery.materials"
                                    item-key="material.id"
                                    sort-by="material.materialName"                                    
                                    class="elevation-1"
                                    hide-default-footer
                                    >
                                <template v-slot:item.materialAction="{ item }">                                                  
                                    <v-icon   
                                    :disabled="!isDeliveryEditable(delivery)"                                 
                                    @click="deleteMaterial(item)"
                                    >
                                    mdi-delete
                                    </v-icon>
                                </template>
                                </v-data-table>
                            </v-flex>  
                            <v-spacer></v-spacer>
                            
                            <v-flex xs12 sm6 md12 > &nbsp;</v-flex>
                            <v-flex xs12 sm6 md10 />
                            <v-flex xs12 sm6 md2>
                                <v-btn v-if="isDeliveryEditable(delivery)" color="success" dark class="mb-2" @click="save">Save Delivery</v-btn>   
                            </v-flex> 
                        </v-layout>    
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        
                            <v-layout wrap >   
                                <v-flex v-if="delivery.id && loaded" xs12 sm6 md12>
                                    <v-data-table
                                        :key="materialTableKey"
                                        :headers="deliveryMaterialReportHeaders"
                                        :items="deliveryMaterialList"
                                        item-key="material.id"
                                        sort-by="material.materialName"                                    
                                        class="elevation-1"
                                        hide-default-footer
                                        >
                                        <template v-slot:top>
                                            <v-toolbar flat color="white">
                                                <v-toolbar-title>Purchase {{delivery.purchase.id}} Details</v-toolbar-title>
                                            </v-toolbar>
                                        </template>    
                                    </v-data-table>
                                </v-flex>  
                            <v-spacer></v-spacer>
                        
                        </v-layout>     
                    </v-col>
                </v-row>
                
            </v-flex>
       </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import Progress from '../../components/Progress';
import Documents from '../../views/Documents';
import breadcrumbs from '../../store/breadcrumbs.js'
import formatPrice from '../../helpers/formatter';
const DELIVERY_API_URL = 'stock/deliveries';
const SUPPLIERS_API_URL = 'definitions/suppliers';
const STOCKS_API_URL = 'stock/stocks';
const SECTIONS_API_URL = 'stock/stockSections';
const PURCHASES_API_URL = 'manufacture/purchases';
const CURRENCIES_API_URL = 'definitions/currencies';
const MATERIALS_API_URL = 'definitions/materials';
export default {
    props: {
    },
    components:{
      LeftMenu,
      DatePicker,
      Documents,
      Progress
    },
    data () {
      return {
        loaded: false,
        showProgress : false,
        suppliers:[],
        purchases:[],
        stockList:[],
        sectionList:[],
        delivery : {},
        materialTableKey : 0,
        currencyList: [],
        totalDeliveryPrice: 0,
        deliveryCurrency : '',
        newMaterial:{}
      }
    },
    computed: {      
        deliveryMaterialHeaders(){
            return [   
                { text: 'Material',  value: 'material.materialName'  },      
                { text: 'Purchased Quantity',  value: 'purchasedQuantity', align: 'center'  },
                { text: 'Delivered Quantity',  value: 'quantity', align: 'center'  },
                { text: 'Stock',  value: 'stockSection.stock.name', align: 'center'  },
                { text: 'Section',  value: 'stockSection.name', align: 'center'  },
                { text: 'Actions', value: 'materialAction', sortable: false },
            ]
        },
        deliveryMaterialReportHeaders(){
            return [   
                { text: 'Material',  value: 'material.materialName'  },      
                { text: 'Purchased Quantity',  value: 'purchasedQuantity', align: 'center'  },
                { text: 'Delivered Quantity',  value: 'deliveredQuantity', align: 'center'  },
            ]
        },
        totalDeliveryPriceFormatted(){
            return formatPrice(this.totalDeliveryPrice);
        },
        convertedText(){
            return "Converted ("+this.delivery.currency.code+')';
        },
        currencyListWithText(){
            return this.currencyList.map((item) => {
                return {
                id: item.id,
                code: item.code,
                text: item.code+' - '+item.text          
                };
            })
        },
        deliveryMaterialList(){
            return this.delivery.purchase.materials.map((item) => {
                var deliveredItemList = this.delivery.materials.filter(x => x.material.id == item.id);
                var deliveredItemQuantity = 0;
                if(deliveredItemList && deliveredItemList.length>0){
                    deliveredItemQuantity = deliveredItemList.reduce((total, obj) => obj.quantity + total,0);
                }
                item.purchasedQuantity = item.quantity;
                item.deliveredQuantity = deliveredItemQuantity;
                return item;    
            })
        }
    },
    created () {
        if(this.$route.params.id != 'new'){
            this.getDelivery(); 
        }else{
            this.delivery.id= 0;
            this.delivery.status = "NEW";
            this.totalDeliveryPrice = 0;
            this.delivery.supplier = {};
            let currentSupplier = breadcrumbs.getters.getSupplier;
            let crumbs = breadcrumbs.getters.getBreadCrumps;
            if( crumbs && crumbs.length>0 && currentSupplier){
                this.delivery.supplier = currentSupplier;
            }
        }
        if(this.delivery && this.delivery.supplier && this.delivery.supplier.id ){
            this.getPurchasesBySupplier(this.delivery.supplier);
        }
        this.getSuppliers();
        this.getCurrencies();
        this.getStockList();
        this.newMaterial = {}; 
    },
    methods: {
        async getDelivery(){
          this.$axios.get(this.$apiurl + DELIVERY_API_URL+'/'+ this.$route.params.id+'/withPurchase')
            .then(response => {
                this.delivery = response.data;
                this.updateBreadCrumbs(response.data);
                this.getDeliveryMaterials();
            }) 
            .catch(error => {
                console.log(error);
            });   
        },
        isDeliveryEditable(delivery){
            return true;
        },
        getSuppliers(){     
          this.$axios.get(this.$apiurl + SUPPLIERS_API_URL)
            .then(response => {
                this.suppliers = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
        },   
        getStockList(){     
          this.$axios.get(this.$apiurl + STOCKS_API_URL)
            .then(response => {
                this.stockList = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
        },
        stockSelected(stock){
            if(!stock) {
                this.sectionList = [];
                this.newMaterial.stockSection = null;
                return;
            }    
            this.$axios.get(this.$apiurl + SECTIONS_API_URL + '/stock/'+ stock.id)
                .then(response => {
                    this.sectionList = response.data;
                }) 
                .catch(error => {
                    console.log(error);
                }); 
        },
        getPurchasesBySupplier(supplier){  
            this.delivery.purchase  = {};
            this.$axios.get(this.$apiurl + PURCHASES_API_URL + '/supplier/'+ supplier.id)
            .then(response => {
                this.purchases = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
        },   
        save () {
            if(!this.delivery.supplier || !this.delivery.supplier.id){
                alert('Supplier cannot be empty!');
                return;
            } 
            if(!this.delivery.status){
                alert('Status cannot be empty!');
                return;
            } 
            //if(!this.delivery.deliveryDate){
            //    alert('Delivery date cannot be empty!');
            //    return;
            //} 
            if (this.$route.params.id != 'new') {        
                this.updateDelivery(this.delivery);
            } else {
                this.addDelivery(this.delivery);         
            }  
        },
        addDelivery(item){
            this.showProgress = true;
            this.$axios.post(this.$apiurl + DELIVERY_API_URL, {
                supplierId: item.supplier.id,  
                purchaseId: item.purchase.id,  
                deliveryDate: item.deliveryDate,
                status: item.status,
                explanation: item.explanation,
                materials: item.materials
            })
            .then(response => {      
                if (response.status === 201) {
                    this.delivery = response.data;
                    this.showProgress = false;
                    this.$radio.$emit('success', {message:'Delivery Created Successfully'});
                    this.$router.push('/deliveries/'+response.data.id);
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        updateDeliveryStatus(status){
            this.$axios.post(this.$apiurl + DELIVERY_API_URL+'/'+this.$route.params.id+'/status/'+status, {})
            .then(response => {        
                if (response.status === 200) {
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
            },
        async addMaterial(delivery){
            await this.$axios.post(this.$apiurl + DELIVERY_API_URL+'/'+this.$route.params.id+'/materials', {
                materialId: this.newMaterial.material.id,        
                quantity: this.newMaterial.quantity ? this.newMaterial.quantity : 1,
                stockSectionId : this.newMaterial.stockSection ? this.newMaterial.stockSection.id : 0
            })
            .then(response => {        
                if (response.status === 201) {
                    this.$radio.$emit('success', {message:'Material Added Sucessfully'});
                } 
            }) 
            .catch(error => {
                console.log(error);
            });      
            this.newMaterial = {};
            await this.getDeliveryMaterials();      
        },
        updateDelivery(item){
            this.$axios.put(this.$apiurl + DELIVERY_API_URL, {
                id: item.id,
                supplierId: item.supplier.id,  
                deliveryDate: item.deliveryDate,
                status: item.status,
                explanation: item.explanation,
                materials: item.materials
            })
            .then(response => {
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Delivery Saved Sucessfully'});
                }         
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        async getDeliveryMaterials(){  
            this.delivery.materials = [];
            this.materialTableKey +=1;      
            this.totalDeliveryPrice = "";
            
            await this.$axios.get(this.$apiurl + DELIVERY_API_URL+'/'+this.$route.params.id+'/materials')
            .then(response => {
                if(response.data && response.data.length>0){
                    this.delivery.materials = response.data;              
                    this.delivery.materials.map((item) => {    
                        item.priceFormatted = formatPrice(item.price);
                        return item;    
                    });
                    this.totalDeliveryPrice =  this.delivery.materials.reduce((acc, item) => acc + item.price, 0); 
                }
            }) 
            .catch(error => {
                console.log(error);
            });   
            
            this.loaded = true;
        },
        materialSelected(item){  
            this.newMaterial.quantity = 1;
            this.newMaterial.price = 0;
        },
        updateBreadCrumbs(item){
            let deliveryText = item.id;
            
            breadcrumbs.dispatch('setBreadCrumps', [
                                      { text: 'Purchases', disabled: false, href: '/#/purchases'},
                                      { text: 'Purchase '+ item.purchase.id, disabled: false, href: '/#/purchases/'+item.purchase.id},
                                      { text: 'Delivery ' +deliveryText, disabled: true } // placeholder
                                  ]);
        },
        async deleteMaterial(item){                  
            if(confirm('Are you sure you want to delete this material?')){ 
                await this.$axios.delete(this.$apiurl + DELIVERY_API_URL+'/'+ this.$route.params.id +'/materials/'+item.id)
                .then(response => {        
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Material Deleted Successfully'});
                } 
                }) 
                .catch(error => {
                console.log(error);
                });            
                await this.getDeliveryMaterials();                 
            }     
        },
        getCurrencies(){     
            this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
        }, 
    }
}
</script>